import moment from 'moment';
import iconv from 'iconv-lite';
import Papa from 'papaparse';
import type { Types as InfoMentorTypes } from '../types';
import type { CoreTypes } from '../../core';
import { getDayIndex } from '../../core/util';
import { isMongooseObjectId } from '../../common/functions';

const days      = ['MÅN', 'TIS', 'ONS', 'TOR', 'FRE'];
const columns   = ['Ämne', 'Dag', 'Starttid', 'Längd', 'Personal', 'Klasser', 'Salar'];
const delimiter = '\t';
const encoding  = 'windows-1252';

export default (courseEvents: CoreTypes.Mixed.Event[]): Buffer => {
  const events = courseEvents
    .map(event => {
      if (event.parked || !event.start || !event.end) return;

      const course = event.course;
      if (!course) return;

      const day = days.at(getDayIndex(event.start));
      if (!day) throw new Error('Invalid event day');

      if (typeof course == 'string' || isMongooseObjectId(course))
        throw new Error('(InfoMentor::To::Schedules) Event course is not an deserialized object');

      const Personal = (event.teachers ?? course.teachers ?? []).map(({ to: x }) =>      typeof x == 'object' && 'displayName' in x ? x.displayName : null).filter(x => x != null).join(',');
      const Klasser  = (event.groups   ?? course.groups   ?? []).map(({ to: x }) =>      typeof x == 'object' && 'displayName' in x ? x.displayName : null).filter(x => x != null).join(',');
      const Salar    = (event.inLocations                 ?? []).map(x           => x && typeof x == 'object' && 'displayName' in x ? x.displayName : null).filter(x => x != null).join(',');

      const doc: InfoMentorTypes.event ={
        Ämne:     course.displayName,
        Dag:      day,
        Starttid: moment.utc(event.start).format('HH.mm'),
        Längd:    moment.utc(event.end).diff(moment.utc(event.start), 'minutes'),
        Personal,
        Klasser,
        Salar,
      };
      return doc;
    });

  const opts = { columns, delimiter };
  const csv = Papa.unparse(events, opts);
  return iconv.encode(csv, encoding);
};
